import { render } from "./VistaPlanta.vue?vue&type=template&id=459951ca"
import script from "./VistaPlanta.vue?vue&type=script&lang=js"
export * from "./VistaPlanta.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__